import { Controller } from "@hotwired/stimulus"

// Turns server-rendered flash messages into cozy toasts: slides each in, then
// auto-dismisses after a few seconds. Manual close via the ✕ button.
export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this.toastTargets.forEach((toast, i) => {
      // Stagger slightly when more than one flash is present.
      requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add("is-in")))
      const timer = setTimeout(() => this.hide(toast), 4000 + i * 250)
      toast.dataset.timer = String(timer)
    })
  }

  dismiss(event) {
    this.hide(event.currentTarget.closest(".toast"))
  }

  hide(toast) {
    if (!toast || toast.classList.contains("is-out")) return
    clearTimeout(Number(toast.dataset.timer))
    toast.classList.add("is-out")
    toast.classList.remove("is-in")

    let removed = false
    const remove = () => {
      if (removed) return
      removed = true
      toast.remove()
    }
    toast.addEventListener("transitionend", remove, { once: true })
    setTimeout(remove, 500) // fallback if transitionend doesn't fire
  }
}
